import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2af0308a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af0308a')) {
      api.createRecord('2af0308a', component.options)
    } else {
      api.reload('2af0308a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2af0308a&", function () {
      api.rerender('2af0308a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29hq2vqokVewN/JS/comp/childrenage.vue"
export default component.exports